import { number } from "prop-types";
import { useEffect, useMemo, useRef } from "react";

import styled from "styled-components";

import { useMemberToobarContext } from "CrossFeatureComponents/MemberToolbar/MemberToolbarState";
import { INNER_MENU_BORDER_RADIUS } from "CrossFeatureComponents/MemberToolbar/styleConstants";

import FnrInput3 from "UI/FnrInput3";
import MultiLineInput from "UI/FnrInput3/Inputs/MultiLineInput";
import { marketingColors } from "UI/colors";

const Input = (props) => {
  const { message, setMessage, activeContentKey, setClickAwayDisabled } =
    useMemberToobarContext();
  const inputRef = useRef();
  const formActive = useMemo(
    () => activeContentKey === "form",
    [activeContentKey]
  );

  useEffect(() => {
    if (formActive) {
      if (typeof inputRef?.current?.focus === "function" && formActive)
        inputRef.current.focus();
    }
  }, [activeContentKey, setClickAwayDisabled, formActive]);

  return (
    <SFnrInput3
      Component={SMultiLineInput}
      value={message}
      setValue={setMessage}
      data-cy="MemberToolbar_ContactInput"
      staticHeight
      autoFocus
      disabled={!formActive}
      ref={inputRef}
      charLimit={5000}
      placeholder="Type your message here..."
      {...props}
    />
  );
};

Input.propTypes = { height: number };

const SMultiLineInput = styled(MultiLineInput)`
  flex-grow: 1;
  background-color: ${marketingColors.grey};
  padding-bottom: 60px;
`;

const SFnrInput3 = styled(FnrInput3)`
  height: 260px;
  display: flex;
  flex-grow: 1;
  border-radius: ${INNER_MENU_BORDER_RADIUS}px;
  overflow: clip;
`;

export default Input;
